export const ERROR_UPLOAD_FILE = 'Во время загрузки файла произошла ошибка!';
export const ERROR_UPLOAD_FILE_TYPE_IMAGE = 'Загрузить можно только файлы с расширением jpeg, jpg, png, webp!';
export const ERROR_UPLOAD_FILE_TYPE_XLSX = 'Загрузить можно только файлы с расширением xlsx!'